import { __ } from "@wordpress/i18n";
import { registerBlockType } from "@wordpress/blocks";
import Edit from "./edit";
import example from "./example";
import icons from "../../util/RTCLGB-icon-controls/icons"

registerBlockType("rtcl/listing-ads-slider", {
	title: __("Listing Slider", "classified-listing"),
	description: __("classified listings", "classified-listing"),
	category: "classified-list-gb",
	icon: {
		src: icons.rtclLogo,
	},
	keywords: [
		__("listing Slider", "classified-listing"),
		__("listings-grid", "classified-listing"),
		__("classified-listing", "classified-listing"),
	],
	//attributes,
	// getEditWrapperProps({ align }) {
	// 	if ('left' === align ||
	// 		'right' === align ||
	// 		'full' === align ||
	// 		'wide' === align
	// 	) { return { 'data-align': align }; }
	// },
	edit: Edit,
	save: () => null,
	//example,
});